<form #invoiceFormRef="ngForm" [formGroup]="invoiceForm">
  <div class="mb-8 grid grid-cols-5 gap-5 rounded-t-md border p-5">
    <div>
      <div class="mb-1 text-sm">Vendor Contract</div>
      <ng-select
        class="select"
        placeholder="Select"
        id="vendor"
        formControlName="vendor_id"
        auxFormError
        required
        [searchable]="false"
        [multiple]="false"
        [clearable]="false"
        [auxTooltip]="formTooltip() || vendorIdTooltip()"
        (change)="onVendorChange()"
      >
        @for (vendor of orgQuery.allVendors(); track vendor.id) {
          <ng-option [value]="vendor.id">{{ vendor.name }}</ng-option>
        }
      </ng-select>
    </div>

    <div>
      <div class="mb-1 text-sm">Invoice Number</div>
      <aux-input
        formControlName="invoice_no"
        class="mb-4"
        validators="required"
        [auxTooltip]="formTooltip()"
      />
    </div>

    <div>
      <div class="mb-1 text-sm">PO #</div>
      <ng-select
        placeholder="Select"
        id="po_reference"
        [searchable]="false"
        [multiple]="false"
        formControlName="selectedPOReference"
        [clearable]="true"
        [ngClass]="{
          'is-invalid': invoiceForm.controls.selectedPOReference.status === 'INVALID',
        }"
        [auxTooltip]="formTooltip()"
      >
        @for (po of filteredPONumbers(); track po.id) {
          <ng-option [value]="po.id">
            {{ po.po_number }}
          </ng-option>
        }
      </ng-select>
    </div>

    <div></div>
    <div></div>

    <div>
      <div class="mb-1 text-sm">Invoice Total</div>
      <aux-input formControlName="invoice_total" [auxTooltip]="formTooltip()" />
    </div>

    @if (!isJEConfigSetToAttribute()) {
      <div>
        <div class="mb-1 text-sm">Services Total</div>
        <aux-input formControlName="services_total" [auxTooltip]="formTooltip()" />
      </div>

      <div>
        <div class="mb-1 text-sm">Discount Total</div>
        <aux-input formControlName="discount_total" [auxTooltip]="formTooltip()" />
      </div>

      <div>
        <div class="mb-1 text-sm">Pass-Through Total</div>
        <aux-input formControlName="pass_thru_total" [auxTooltip]="formTooltip()" />
      </div>

      <div>
        <div class="mb-1 text-sm">Investigator Total</div>
        <aux-input formControlName="investigator_total" [auxTooltip]="formTooltip()" />
      </div>
    }

    @if (!isDecline()) {
      <div>
        <div class="mb-1 text-sm">Posting Period</div>
        <aux-input
          formControlName="accrual_period"
          [disabled]="isFormDisabled()"
          [type]="'month'"
          [max]="maxDate()"
          [min]="accrualMinDate()"
          [auxTooltip]="formTooltip()"
          [validators]="accrualValidators"
          [customErrorMessages]="customErrorMessages"
        />
      </div>
    }

    <div>
      <div class="mb-1 text-sm">Service Period</div>
      <aux-input
        formControlName="services_period"
        [type]="'month'"
        [max]="maxDate()"
        [auxTooltip]="formTooltip('services_period')"
        [validators]="servicesPeriodValidators"
        [customErrorMessages]="customErrorServicesPeriodMessages"
      />
    </div>

    <div>
      <div class="mb-1 text-sm">Invoice Date</div>
      <aux-input
        formControlName="invoice_date"
        validators="required"
        [type]="'date'"
        [auxTooltip]="formTooltip()"
      />
    </div>

    <div>
      <div class="mb-1 text-sm">Due Date</div>
      <aux-input formControlName="due_date" [type]="'date'" [auxTooltip]="formTooltip()" />
    </div>
  </div>

  <aux-invoice-detail-invoice-notes
    class="mb-8 block"
    [notes]="invoiceForm.controls.notes.value"
    (notesChange)="invoiceForm.controls.notes.setValue($event)"
    (saveNotes)="saveNotes()"
    (cancelNotes)="cancelNotes()"
  />
</form>
